<template>
    <div class="Withdrawal">
        <component :is="payType==53?BankTransfer:payType==3?USDTWithdraw:payType==51?NormalWithdraw:payType==2?BlockChainWithdraw:''" :fundAccountId="fundAccountId" :payId="payId" :fundAccountName="fundAccountName"></component>
    </div>
</template>
<script>
import {
 ref,computed
} from 'vue';
import apiService from '@/api/request';
import BankTransfer from './components/BankTransfer'
import BlockChainWithdraw from './components/BlockChainWithdraw'
import NormalWithdraw from './components/NormalWithdraw'
import USDTWithdraw from './components/USDTWithdraw'
import { useStore } from 'vuex';
import { useRoute } from "vue-router"

export default {
    name:'Withdrawal',
    components:{
        BankTransfer,
        BlockChainWithdraw,
        NormalWithdraw
    },
    setup(){
        const store = useStore();
        const route = useRoute(); 

       
        const payType = ref(route.query.payType);
        const payId = ref(route.query.payId);
        const fundAccountId = ref(route.query.fundAccountId);
        const fundAccountName = ref(route.query.fundAccountName);
        console.log("payType",payType.value)
        

        return {
            BankTransfer,
            BlockChainWithdraw,
            NormalWithdraw,
            USDTWithdraw,
            payType,
            payId,
            fundAccountId,
            fundAccountName
        }
    }
}
</script>
<style lang="less" scoped>
.Withdrawal{

}
</style>
<style lang="less">
.Withdrawal{
     .el-tabs__nav{
        float: none;
    }
    .el-tabs__item{
        padding-right:0 !important;
        padding-left:0 !important;
    }
}
</style>
